import React from 'react';
import Svg from 'react-native-svg';
import withPress from 'src/hoc/withPress';
import { isWeb } from 'src/utils/platform';
import withNotificationCount from './withNotificationCount';
const units = isWeb ? 'px' : 'em';
const SVGIcon = withPress(withNotificationCount(({ size = 24, notificationCount, ...rest }) => (React.createElement(Svg, { height: `${size}${units}`, width: `${size}${units}`, viewBox: "0 0 24 24", ...rest }))));
export default SVGIcon;
